import {Grid, TextField, TextFieldProps, TextFieldVariants, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';


const MyTextField = <Variant extends TextFieldVariants>({label, ...props}: {
    variant?: Variant;
} & Omit<TextFieldProps, 'variant'>): JSX.Element => {

    const theme = useTheme();

    const labelStyle = {
        color: props.disabled 
            ? theme.s10palette.S10Greygrey300 
            : theme.s10palette.S10Greygrey700,
        fontSize: "1rem",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "1.25",
    };

    const inputStyles = {
        width: "20rem", 
        height: "2.5rem", 
        fontSize: "1rem",
        // border: "none",
        // padding: "0.35rem 0.75rem",
        margin: "0px",
        background: "white",
        borderRadius: "0.25rem",
        ...props?.style,
    };
    if (props.value && !props.error) {
        inputStyles.border = `1px solid ${theme.s10palette.S10Blueblue300}`;
        inputStyles.borderRadius = "0.25rem"
    }
    if (props.error) {
        inputStyles.border = `1px solid ${theme.s10palette.S10Redred500}`;
        inputStyles.borderRadius = "0.25rem"
    }
    return (
        <Grid item>
            {label && <Typography 
                // variant="caption"
                align='left'
                style={labelStyle}
            >
                {label}
            </Typography>}
            <TextField 
                {...props}
                hiddenLabel
                variant="outlined"
                // style={{...inputStyles  ,}}
                InputProps={{...props.InputProps, style: inputStyles}}
            />
        </Grid>
    );
}

export default MyTextField;